<div
  #tooltip
  class="mdc-tooltip mdc-tooltip--shown mat-mdc-tooltip"
  [ngClass]="tooltipClass"
  (animationend)="_handleAnimationEnd($event)"
  [class.mdc-tooltip--multiline]="_isMultiline">
  <div class="mdc-tooltip__surface mdc-tooltip__surface-animation">{{message}}</div>
</div>
